// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"104":"cc0ed160","142":"5312ecc6","145":"f1840d1c","383":"32258792","705":"2e4e7104","794":"9c24c49c","808":"11d72797"}[chunkId] + ".js";
};